module.exports = __webpack_public_path__ + "static/img/img-about-3.64500fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-about-3.png
// module id = X/0v
// module chunks = 0